module.exports = __webpack_public_path__ + "img/Gruppenführer_B.8a48bf44.svg";